<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";

  const onclick = () => {
    window.open("/meetings?register=true", "_blank");
  };
</script>

<div>
  <Button size="large" {onclick}>Request free trial</Button>
</div>
